/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workflow_Connect_HintInputs */

const cs_workflow_connect_hint = /** @type {(inputs: Workflow_Connect_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Přetažením z výstupního portu uzlu na vstupní port jiného uzlu je propojíte.`)
};

const en_workflow_connect_hint = /** @type {(inputs: Workflow_Connect_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drag from a node's output port to another node's input port to connect them.`)
};

/**
* | output |
* | --- |
* | "Drag from a node's output port to another node's input port to connect them." |
*
* @param {Workflow_Connect_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const workflow_connect_hint = /** @type {((inputs?: Workflow_Connect_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workflow_Connect_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_workflow_connect_hint(inputs)
	return cs_workflow_connect_hint(inputs)
});